import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';
import { environment } from '../environments/environment';
import * as _ from 'lodash';

@Injectable()
export class AppConfig {

  constructor() {}

  load() {

    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }

  get(key: any) {
      return environment.config[key];
  }
};


// WEBPACK FOOTER //
// ./src/app/app.config.ts